module.exports = __webpack_public_path__ + "img/external-link.8fa87884.svg";